export default __webpack_public_path__ + "static/media/checkmark-circle.3fee538f.svg";